import { GatewayControleQuinquennal } from "@conformite/gateway";
import {
  formatEstimatedCost,
  formatEstimatedDuration,
} from "@src/helper/analyseEstimation.helper";

type AnalyseEstimationMessageProps = {
  message: string;
  estimation?: GatewayControleQuinquennal.ControleQuinquennalAnalyseEstimationResponse;
};

/**
 * Message d'un `ConfirmDialog` de lancement/relance CQ, complété d'un bloc
 * d'estimation coût/durée (conception EN-1476 §5).
 *
 * Contenu strictement inline (`<strong>`, `<br/>`) : `ConfirmDialog` rend
 * `message` dans un `<p>`, un élément de bloc y produirait du HTML invalide.
 *
 * Chaque ligne n'est rendue que si sa valeur est non nulle. Les deux nulles
 * (estimation absente, en erreur, en cours, ou sous le seuil côté gateway) :
 * aucun bloc, le message redevient celui de la modale de confirmation
 * actuelle — jamais de valeur de repli, jamais de chiffre inventé.
 */
export function AnalyseEstimationMessage({
  message,
  estimation,
}: AnalyseEstimationMessageProps) {
  const duration = estimation?.estimatedDurationSeconds;
  const cost = estimation?.estimatedCostUsd;

  if (duration == null && cost == null) {
    return <>{message}</>;
  }

  return (
    <>
      {message}
      <br />
      <br />
      {duration != null && (
        <>
          Durée estimée : <strong>{formatEstimatedDuration(duration)}</strong>
        </>
      )}
      {duration != null && cost != null && <br />}
      {cost != null && (
        <>
          Coût estimé : <strong>{formatEstimatedCost(cost)}</strong>
        </>
      )}
    </>
  );
}
